import { useState } from 'react'
import { InputFormat } from '@laramie/ui';
import FormLabel from '../FormLabel'

import './index.scss'

const InputSecret = ({ title, name, value, onChange, onPressEnter, maxLength, disabled, autoComplete, mask, maskPlaceholder, htmlFor, required, invalid }) => {
    const [hidden, setHidden] = useState(true)

    return (
        <>
            <FormLabel htmlFor={htmlFor ?? name} required={required}>{title}</FormLabel>
            <div className="input-secret-container">
                <input
                    className={`form-control${invalid ? ' is-invalid' : ''}`}
                    readOnly
                    aria-hidden
                    tabIndex={-1}
                    disabled={disabled}
                />
                <div className='input-secret-sub-container'>
                    <InputFormat
                        {...{name, value, onChange, maxLength, disabled, autoComplete, mask, maskPlaceholder, required}}
                        type={hidden ? "password" : "text"}
                        placeholder=""
                        className="form-control input-secret-text"
                        onKeyUp={({ key }) => { if (key === 'Enter') onPressEnter?.() }}
                    />
                    <div className='input-secret-icon-container' onClick={() => setHidden(x => !x)}>
                        <span className="material-symbols-outlined input-secret-icon" title="Ver">
                            {hidden ? 'visibility_off' : 'visibility'}
                        </span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default InputSecret
